// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1N3C_zTX2ola9PUDR_WA1","circle":"_1vrAbZJ9pzIpxFYRU_8fim","name":"_27e7Wa0E7ybnozlG0XKmpQ","withIcon":"I6qsgKSL1GfUGFLP5k-qQ","complete":"_3OoqWeXDMH7H3ST6Ferv9H","incomplete":"iRbYiVOp_LdU3YDC4w0-c","current":"_2rfnjJrHUkUdjRx5NAKkb9","circle-progress":"_1HNwgcPbJF4YP9CGMzge1d","tablet":"_2xrq6ZtrODehZ3wzlaNH0B","icon":"_2SGOOoiVvb0aIfHOrxR7mI","secondary":"_1G8CM4IudGlX2mwKGaXdNU"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/components/ModuleCircle.mod.css
// module id = 1609
// module chunks = 0